import React, { useState, useEffect } from "react";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { formatCmsHtml } from "../../utils/formatCmsHtml";
import "../Policy/PolicyPages.css";

const TermsAndConditions = () => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const response = await service.get(
                    endpoints.cms.termsConditions,
                    {},
                    { headers: { Authorization: undefined } }
                );

                if (response?.data?.success) {
                    setContent(response?.data?.data || "");
                } else {
                    setErrorMessage(
                        response?.data?.message ||
                        "Unable to fetch terms and conditions content."
                    );
                }
            } catch (error) {
                console.error("Terms API error:", error);
                setErrorMessage(
                    error?.response?.data?.message ||
                    "An error occurred while loading content."
                );
            } finally {
                setLoading(false);
            }
        };

        fetchTerms();
    }, []);

    if (loading) {
        return (
            <div className="view-policy-wrapper">
                <div className="policy-loading-container">
                    <div className="policy-loader" />
                    <p>Loading, please wait...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="view-policy-wrapper">
            <div className="view-policy-container">
                <div className="terms-heading mb-4">
                    <h4>Terms & Conditions</h4>
                </div>

                <div className="view-policy-content">
                    {errorMessage ? (
                        <div className="policy-error-container">
                            <p>{errorMessage}</p>
                        </div>
                    ) : content ? (
                        <div
                            className="policy-body"
                            dangerouslySetInnerHTML={{
                                __html: formatCmsHtml(content),
                            }}
                        />
                    ) : (
                        <div className="policy-error-container">
                            <p>No content available.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
